import React, { Component } from 'react';

import LoginWithRouter  from "./login";


export default class AuthPage extends Component {
    constructor(props) {
        super(props);
     
        
    }
    render() {
        const CDN = window.CDN;
       
        return (
            <div className="limiter auth-page">
                <div className="container-login100">
                    <div className="wrap-login100">
                        <div className="login100-more" style={{ backgroundImage: "url('img/bg1.jpg')" }}>
                            <div className="row align-items-center" >
                                <div className="col-12 m0">
                                    <a href="/home">
                                        <img src={CDN.replace("{0}", "/img/logo.png")} height="70" alt="" />
                                    </a>
                                </div>
                                <div className="col-12 mt20">
                                    <div className="intro">

                                        <p><strong>Google Documents</strong> are great. <strong>GStitch makes them way better:</strong></p>
                                        <ul>
                                            <li>Customer facing docs that looks great</li>
                                            <li>Cohesive presentation of multiple docs</li>
                                            <li>Manage docs separately, display them centrally</li>
                                        </ul>
                                    </div>
                                    <div className="intro2">
                                        <p>Collaborate with your team members, contractors, and consultants in one place. Easily invite others to contribute or manage.</p>
                                        <p>Use templates and presentation options to brand your documentation and resources for the best customer facing presentation.</p>
                                        <p>Keep your documents fresh, consolidated, and rendering perfectly on all devices.</p>
                                    </div>
                                </div>
                            </div>


                            <footer className="text-center text-small footer" style={{
                                position: "absolute",
                                bottom: "0",
                                left: "0",
                                width: "100%",
                                height: "40px"
                            }}>
                                <p className="mb-1 ml-5 pull-left">&copy; {new Date().getFullYear()} gstitch</p>
                                <ul className="list-inline pull-right mr-5">
                                    <li className="list-inline-item"><a href="/contact">Contact Us</a></li>
                                    <li className="list-inline-item"><span> | </span></li>
                                    <li className="list-inline-item"><a href="/tos" >Terms & Conditions</a></li>
                                </ul>
                            </footer>
                        </div>
                        <div className="login100-form">
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%"
                            }}>
                              
                                <LoginWithRouter getUserInfo={this.props.getUserInfo} ></LoginWithRouter>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
